/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import {
  Box,
  StepConnector,
  stepConnectorClasses,
  Typography,
} from '@mui/material';
import _ from 'lodash';
import emptyIcon from '../../../assets/images/empty_icon.svg';
import { fonts, themes } from '../../themes/themes';
import Loader from '../../Lottifiers/Loader/Loader';
import styled from '@emotion/styled';
import Compdirection from '../../themes/CompDirection';
import { baseDateFormatting } from '../../helper';
import { DateField } from '../../../components';

interface PropsValue {
  allSteps?: any;
  pendingWithData?: any;
  isLoading: boolean;
  trans?: any;
}

const CustomStepper = styled(Stepper)(() => ({
  '& .MuiStepLabel-iconContainer-active': {
    backgoundColor: themes.defaultSuccess,
  },
  '& .MuiStepLabel-root': {
    padding: 0,
  },
  '& .MuiStepIcon-root.Mui-active': {
    color: themes.defaultSuccess,
  },
  '& .MuiStepIcon-root.Mui-completed': {
    color: themes.defaultSuccess,
  },
  '& .MuiStepIcon-root': {
    color: themes.greyDefault_500,
  },

  '& .MuiStepLabel-label.Mui-completed': {
    color: themes.greyDefault,
    fontFamily: fonts.fontFamily,
    fontWeight: 'bold',
  },
  '& .MuiStepLabel-label.Mui-active': {
    color: themes.blackDefault,
    fontFamily: fonts.fontFamily,
  },
  '& .MuiStepLabel-label': {
    color: themes.blackDefault,
    fontFamily: fonts.fontFamily,
  },
  '& .MuiStepConnector-line': {
    minHeight: '32px',
  },
}));

const QontoConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: themes.defaultSuccess,
      borderWidth: '0.1em',
    },
  },
}));

const VerticalBarPresenter = ({
  allSteps,
  pendingWithData,
  isLoading,
  trans,
}: PropsValue) => {
  const [activeStep, setActiveStep] = useState<any>();

  const Label = (props: any) => {
    return (
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography
          style={{
            fontFamily: fonts.fontFamily,
            fontWeight: 'bold',
            fontSize: '0.82em',
            color: props?.name == 'Reject' ? themes.defaultError : '#081735',
          }}
        >
          {props?.name}
        </Typography>
        {props.approver && (
          <Typography
            variant="caption"
            style={{
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
            }}
          >
            {props?.approver ? props?.approver : ''}
          </Typography>
        )}
        <Typography
          variant="caption"
          style={{
            fontFamily: fonts.fontFamily,
            color: props?.name == 'Reject' ? themes.defaultError : '#081735',
          }}
        >
          {props?.subheader && (
            <DateField value={props?.subheader} format={baseDateFormatting} />
          )}
        </Typography>
      </Box>
    );
  };
  useEffect(() => {
    if (pendingWithData) {
      setActiveStep(allSteps?.length);
    } else {
      const active_step = allSteps?.length - 1;
      setActiveStep(active_step);
    }
  }, [allSteps, pendingWithData]);
  console.log('allSteps', allSteps.length);
  console.log('pendingWithData', pendingWithData);
  return isLoading ? (
    <Loader height={100} width={200} />
  ) : allSteps?.length || pendingWithData?.length ? (
    <>
      <Compdirection>
        <CustomStepper
          nonLinear
          activeStep={activeStep}
          connector={<QontoConnector />}
          orientation="vertical"
          style={{
            color: '#8181A5',
            fontFamily: fonts.fontFamily,
            fontSize: '0.625em',
            marginTop: '1em',
          }}
        >
          {_.map(allSteps, (step: any) => {
            const labelProps = {};
            if (allSteps?.length == 1 && !pendingWithData) {
              return (
                <Step key={step.id} completed={true}>
                  <StepLabel
                    error={step?.step?.step_name == 'Reject'}
                    icon={
                      step?.step?.step_name == 'Reject' ? (
                        <i
                          className="las la-times"
                          color={themes.defaultError}
                          style={{
                            fontSize: '3em',
                            color: 'red',
                          }}
                        />
                      ) : (
                        ''
                      )
                    }
                  >
                    <Label
                      {...labelProps}
                      name={trans('Started')}
                      subheader={step?.updated_at}
                      approver={
                        step?.actor
                          ? step?.actor?.first_name +
                            ' ' +
                            step?.actor?.last_name
                          : ''
                      }
                    />
                  </StepLabel>
                </Step>
              );
            } else {
              return (
                <Step key={step.id} completed={true}>
                  <StepLabel
                    error={step?.step?.step_name == 'Reject'}
                    icon={
                      step?.step?.step_name == 'Reject' ? (
                        <i
                          className="las la-times"
                          color={themes.defaultError}
                          style={{
                            fontSize: '3em',
                            color: 'red',
                          }}
                        />
                      ) : (
                        ''
                      )
                    }
                  >
                    <Label
                      {...labelProps}
                      name={step?.step?.step_name}
                      subheader={step?.updated_at}
                      approver={
                        step?.actor
                          ? step?.actor?.first_name +
                            ' ' +
                            step?.actor?.last_name
                          : ''
                      }
                    />
                  </StepLabel>
                </Step>
              );
            }
          })}

          {pendingWithData?.name && (
            <Step key={pendingWithData?.id} completed>
              <StepLabel
                error={true}
                icon={
                  <i
                    className="las la-exclamation-triangle"
                    color={themes.defaultError}
                    style={{
                      fontSize: '3em',
                      color: themes.defaultError,
                    }}
                  />
                }
              >
                <Label
                  name={pendingWithData?.current_step}
                  subheader={pendingWithData?.created_at}
                  approver={`${trans(
                    'Pending with',
                  )}: ${pendingWithData?.name}`}
                />
              </StepLabel>
            </Step>
          )}
        </CustomStepper>
      </Compdirection>
    </>
  ) : (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img src={emptyIcon} />
      <Typography
        style={{
          fontFamily: fonts.fontFamily,
          fontSize: fonts.title,
          color: themes.greyDefault,
        }}
      >
        {trans('No Tracking details found')}
      </Typography>{' '}
    </div>
  );
};
export default VerticalBarPresenter;
